import { useTranslation } from "react-i18next"
import { ActionPlanDrawer,} from "../actionPlanDrawer"
import { DrawerEvidences } from "../../../../components/evidences"
import SimpleModal from "../../../../components/modal/simpleModal"
import { Box, Grid, Icon, Typography } from "@mui/material"
import { icons } from "../../../../utils/icons"
import { useQuestionnaireContext } from "../../pages/detail/contextProvider"
import { useStyles } from "./styles"
import { ReportFolioByAnswer } from "../../pages/detail/fragments/reportFolioByAnswer"
import { DynamicFormRef } from "../../../../components/dynamicFormRef"
import { Reincidence } from "../reincidence"
import { FloatProps } from "./type"

type DisplayTypes = {
    actionPlan?: boolean
    evidence?: boolean
    reportFolio?: boolean
    comments?: boolean
    permitting?: boolean
    reincidence?: boolean
}
const FloatsComponents = ({ actionPlan, evidence, reportFolio, display, comments, isGeneral, reincidence, cancelActionPlan }: FloatProps) => {
    const { modal, loading, closeModal } = useQuestionnaireContext()
    const styles = useStyles()
    const { t } = useTranslation()
    return (
        <>
            {
                Boolean(display.actionPlan) && (
                    <ActionPlanDrawer
                        cancel={cancelActionPlan}
                        isGeneral={isGeneral}
                        areThereSomeEvidence={false}
                        arrowBack={actionPlan.arrowBack}
                        validate={false}
                        DrawerProps={{
                            open: !!actionPlan.open
                        }}
                        defaultValues={{
                            EvidenceData: actionPlan?.defaultValues?.evidence,
                            data: actionPlan?.defaultValues?.data ?? { maxReject: '1' },
                            description: actionPlan?.defaultValues?.description ?? {},
                            evidenceFolio: actionPlan?.defaultValues?.evidenceFolio,
                            dataFolios: actionPlan?.defaultValues?.dataFolios,
                            options: actionPlan?.defaultValues?.options
                            // limitFolio: actionPlan?.defaultValues?.limitFolio ?? defaultFoliosLimit,
                            // rejectsFolio: actionPlan?.defaultValues?.rejectsFolio ?? defaultFoliosReject(t)
                        }}
                        activeFolios={!!actionPlan?.defaultValues?.activeFolios}
                        questName={actionPlan.title as string ?? ""}
                        reportFolioOpen={false}
                        shrink={() => { }}
                    />
                )
            }

            {
                Boolean(display.evidence) && (
                    <DrawerEvidences
                        refsByKey={evidence?.data?.refsByKey}
                        defaultValues={evidence?.data?.evidencesData}
                        open={evidence?.data?.openEvidenceDrawer}
                        setRef={evidence?.data?.setRef}
                        save={(data) => { evidence?.saveEvidence(data || []) }}
                        cancel={evidence?.data?.cancelEvidence}
                        headerLabel={`Volver a Configuración${isGeneral ? 'de Cuestionario' : ''}`}
                    />
                )
            }
            {
                Boolean(display.comments) && (
                    <DrawerEvidences
                        headerLabel={`Volver a Configuración${isGeneral ? 'de Cuestionario' : ''}`}
                        headerElement={(
                            <Box sx={styles.header}>
                                <Typography sx={styles.titleEvidences}>Comentario de cierre</Typography>

                                <DynamicFormRef
                                    ref={comments?.ref}
                                    model={{
                                        comment: {
                                            id: 'comment',
                                            label: 'El comentario de cierre es obligatorio',
                                            name: 'comment',
                                            type: 'switch',
                                            wrapper: (payload) => (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    children={payload.children}
                                                    key={payload.id}
                                                />
                                            )
                                        },
                                    }}
                                    defaultValues={comments?.defaultComment}
                                    parentWrapper={(parent) => <Grid container spacing={1} children={parent.children} />}
                                />

                                <Typography sx={styles.titleEvidences}>Evidencias</Typography>
                            </Box>
                        )}
                        refsByKey={comments?.evidence?.data?.refsByKey}
                        defaultValues={comments?.evidence?.data?.evidencesData}
                        open={comments?.evidence?.data?.openEvidenceDrawer}
                        setRef={comments?.evidence?.data?.setRef}
                        save={(data) => { comments?.evidence?.saveEvidence(data || []) }}
                        cancel={comments?.evidence?.data?.cancelEvidence}
                    />
                )
            }

            <ReportFolioByAnswer {...reportFolio} />

            <Reincidence saveReincidence={reincidence?.saveReincidence} close={reincidence?.close} open={reincidence?.open} data={reincidence?.data}/>
            <SimpleModal
                icon={!!modal?.icon ? <Icon sx={styles.warningIcon}>{icons(modal.icon)}</Icon> : undefined}
                open={!!modal.open}
                close={() => {
                    if (modal.cancel) { modal.cancel() }
                    else {
                        closeModal()
                    }
                }}
                title={modal.title}
                removeClose={!modal.cancel}
                description={modal.description}
                cancelText={modal.cancelText ?? t('general.cancel')}
                buttonText={modal?.confirmText ?? t('general.confirm')}
                back={modal.cancel ? () => { if (modal.cancel) modal.cancel() } : undefined}
                loadingButton
                isLoading={!!loading.modal}
                next={() => {
                    if (modal.confirm) modal.confirm()
                    else { closeModal() }
                }}
            />
        </>
    )
}
export type { DisplayTypes }
export { FloatsComponents }